export default "__VITE_ASSET__CNrqEvm0__"